import { Component, OnInit, ViewChild } from '@angular/core';
import { StudentsService } from 'src/app/shared/services/students.service';
import { ParentsService } from 'src/app/shared/services/parents.service';
import { ProfileService } from "src/app/shared/services/profile.service";
import { IStudentResume } from '../../student-list-widget/models/IStudentResume';
import { IStudentHotspot } from './models/IStudentHotspot';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms'; 
import { AnyMxRecord } from 'dns';
import { LoggingService } from "src/app/shared/services/logging.service";
import * as m from 'moment';

@Component({
  selector: 'app-student-hotspot',
  templateUrl: './student-hotspot.component.html',
  styleUrls: ['./student-hotspot.component.scss']
})
export class StudentHotspotComponent implements OnInit {
  @ViewChild('requestForm') requestForm!: NgForm;
  studentHotspotRequest: IStudentHotspot[] = [];   
  students: IStudentResume[] = [];
  parentName: string = "";
  parentPhonenumber:string = "";
  currentDate: string = (new Date()).toISOString().substring(0,10);
  parentProfile: any;
  legalConsent: boolean = false;
  lastUpdated: any;

  studentHotspotCheckboxGroups : any = [];
  studentHotspotRequestSubmission: IStudentHotspot[] = [];   

  constructor(
    private parentService: ParentsService,
    private toastr: ToastrService,
    private studentService: StudentsService,
    private profileService: ProfileService,
    private loggingService: LoggingService
  ) { }

  ngOnInit(): void {
    this.fetchParentProfile();
    this.fetchSubmittedHotspotData();
  }

  fetchParentProfile(){
    this.profileService.getProfile().subscribe({
      next: (profile) => {
        this.parentProfile = profile;
        console.log('Profile:', profile);
        this.lastUpdated = m();
      },
      error: (err) => {
        console.error('Failed to load profile:', err);
      },
    });
  }
  
  fetchSubmittedHotspotData(){
    this.parentService.getStudentHotspotByParentId().subscribe(
      (students) => {        
        this.bindToCheckboxGroups(students);
      },
      (error) => {      
        this.toastr.error(`Can't load Students - error Occured - ${error}`);
      }
    );   
  }

  bindToCheckboxGroups(hotspotStudents: IStudentHotspot[]) {
    console.log(hotspotStudents);
    let checkboxGroups: any = [];

    if (!Array.isArray(hotspotStudents)) {
      console.error("Expected an array for hotspotStudents but got:", hotspotStudents);
      return;
    }
    
    this.studentHotspotRequest = hotspotStudents;
  
    this.studentHotspotRequest.forEach((student) => {
      let studentCheckboxGroup = {
        name: `${student.studentFirstName} ${student.studentLastName}`,
        selected: student.hotspotRequest  === "Y", // true = checked
        requestDate: this.formatDateTime(student.signatureDate),
        qrCodeLink: "../../" + student.studentId + "/buspassqrcodes",
        displayQRCode: true,
        hotspotEligibility: null
      };

      this.parentService.getStudentHotspotEligibility(student.studentId).subscribe((response) => {
        studentCheckboxGroup.hotspotEligibility = response.hotspotEligibility;
      });

      console.log("studentCheckboxGroup", studentCheckboxGroup);
      checkboxGroups.push(studentCheckboxGroup);
    });
  
    this.getAllStudentsByParentToCompareWithSubmittedRequests(checkboxGroups);
  }
  
  getAllStudentsByParentToCompareWithSubmittedRequests(submittedHotspotRequestsRadioGrps: any) {
    // get all Students under this parent
    this.parentService.getStudentsByParent().subscribe(
      (students) => {
        if (Array.isArray(students)) {
          let filteredStudents = students.filter(x => x.enrollmentStatus == "Y");
          this.CheckforAllStudentRequestsSubmit(filteredStudents, submittedHotspotRequestsRadioGrps);
        } else {
          console.error('Expected an array but got:', students);
        }
      },
      (error) => {
        this.toastr.error(`Can't load Students - ${error}`);
      }
    );
  }

  CheckforAllStudentRequestsSubmit(associatedStudents: IStudentResume[], submittedHotspotCheckboxGroups: any) {
    this.students = associatedStudents;
    console.log(this.students);
    console.log(this.studentHotspotRequest);
  
    if (this.students.length !== submittedHotspotCheckboxGroups.length) {
      this.students.forEach(student => {
        const alreadyExists = this.studentHotspotRequest.some(
          x => x.studentId === student.studentId
        );
  
        if (!alreadyExists) {
          let studentCheckboxGroup = {
            name: `${student.firstName} ${student.lastName}`,
            selected: false,
            requestDate: '',
            qrCodeLink: '',
            displayQRCode: false,
            hotspotEligibility: null
          };
          this.parentService.getStudentHotspotEligibility(student.studentId).subscribe((response) => {
            studentCheckboxGroup.hotspotEligibility = response.hotspotEligibility;
          });
          submittedHotspotCheckboxGroups.push(studentCheckboxGroup);
        }
      });
    }
  
    submittedHotspotCheckboxGroups.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  
    this.studentHotspotCheckboxGroups = submittedHotspotCheckboxGroups;
  }

  onSubmit(){
    const hotspotRequest = "Y";
    this.studentHotspotCheckboxGroups.forEach(student => {     
      if(student.selected && student.requestDate == ''){
        let associatedStudent = this.students.find(x => student.name.includes(x.firstName));
        this.studentHotspotRequestSubmission.push(this.addstudentHotspotRequest(associatedStudent, hotspotRequest)) ;
      }
    });

    console.log("studentHotspotRequestSubmission", this.studentHotspotRequestSubmission);

    if (this.studentHotspotRequestSubmission.length > 0) {
      this.parentService
        .saveHotspotRequest(this.studentHotspotRequestSubmission)
        .subscribe(
          (response) => {
            this.toastr.success('Student hotspot request saved successfully!', 'Success');
            console.log(response); 
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          },
          (error) => {
            this.toastr.error('Failed to save hotspot request.', 'Error');
            console.error(error); 
          }
        );
    }else {
      this.toastr.error('No valid student hotspot requests to submit.', 'Error');
    }
  }

  addstudentHotspotRequest(student: IStudentResume, hotspotRequest: string): IStudentHotspot {
    this.logRequest(student.studentId);

    let studentHotspotRequest: IStudentHotspot = {
      hotspotRequestId: 0,
      schoolyear: '0',
      parentId: this.parentService.parentId,
      parentFirstName: this.parentProfile.firstName,
      parentLastName: this.parentProfile.lastName,
      parentEmail: this.parentProfile.email,
      studentId: student.studentId,
      studentFirstName: student.firstName,
      studentLastName: student.lastName,
      costCenterCode: student.costCenterCode,
      schoolDescription: student.locationCode,
      gradeCode: student.gradeLevel,
      region: student.locationCode,
      hotspotRequest: hotspotRequest,
      signatureDate: new Date(),
      signature: this.parentName,
      phoneNumber: this.parentPhonenumber,
      isNotificationSent: false
    };
    return studentHotspotRequest;
  }
  
  onCancel() {    
    return ['../timeline'];
  }

  disableHotspotRequest(studentHotspotGroup: any){
    const requestDate = studentHotspotGroup.requestDate;
    const eligiblity = studentHotspotGroup.hotspotEligibility;

    if(requestDate !== '' ||  eligiblity == 'Ineligible'){      
      return true;
    }
    else{
      return false;
    }
  }

  isSubmitEnabled(): boolean {
    const isAnyStudentSelected = this.studentHotspotCheckboxGroups.some(group => group.selected && group.requestDate == '');
    const isFormValid = this.requestForm?.valid;
    return isFormValid && isAnyStudentSelected && this.legalConsent;
  }

  onPhoneNumberChange(val: string, control: string) {
    var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/); if (x != null) val = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    if (control == "parentPhonenumber") {
      this.parentPhonenumber = val;
    }
  }

  formatDateTime(isoString: any): string {
    const date = new Date(isoString.toString());
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
  }

  onAlphabetsOnly(event: any) {
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) ||
      (charCode > 96 && charCode < 123) ||
      charCode == 8 || charCode == 32) {
      return true;
    }
    else {
      return false;
    }
  }

  logRequest(studentId: any){
    this.loggingService.insertLogging(studentId, 'Request for Hotspot');
  }

}
